// removed by extract-text-webpack-plugin
module.exports = {"headerContainer":"_3HKI8uigYrg-bDv5RFJZe-","header":"_11cprdHWHq9Ec1c1WCbLoB","actionsContainer":"_2Qyw0H4wVkgDnk-974XPOc","toggleEditBtn":"_3LMwPqrPKDQ3LQND3zXaC9","saveClientProfileData":"_1qxuiLIkSRD88j4265kVm1"};


//////////////////
// WEBPACK FOOTER
// ./components/easinsure/client-profile/ClientProfileDataWrapper.scss
// module id = 501
// module chunks = 0